import { useCallback } from 'react';
import { useWorkspaceStore } from '../../core/store/workspaceStore';
import type { WorkspaceTabComponentProps } from '../../core/types/workspaceTypes';
import { isQueryTab } from '../../core/types/workspaceTypes';
import { QueryEditorTabContent } from './QueryEditorTabContent';

export function QueryEditorTab({ tabId, className = '' }: WorkspaceTabComponentProps) {
  if (
    typeof window !== 'undefined' &&
    (window as unknown as { __SQL_STUDIO_PROFILE__?: boolean }).__SQL_STUDIO_PROFILE__
  ) {
    console.log('[PROFILE] QueryEditorTab render');
  }
  const currentTab = useWorkspaceStore(
    useCallback((state) => state.tabs.find((tab) => tab.id === tabId), [tabId])
  );
  // Type guard — this component only renders for query tabs. The guard MUST run
  // before any other hooks, so the hook-heavy body lives in
  // QueryEditorTabContent, which mounts only once the guard passes. (Splitting
  // the early return out of the hook block is what makes the component
  // Rules-of-Hooks compliant.)
  if (!currentTab || !isQueryTab(currentTab)) {
    return null;
  }
  return <QueryEditorTabContent tabId={tabId} className={className} currentTab={currentTab} />;
}
